<script>
  // import { mapState } from 'vuex'
  export default {
    name: 'AutocompleteSelect',
    props: ['form', 'placeholder', 'rules', 'field', 'label', 'items', 'dense', 'color', 'maxlength', 'disabled'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field]
        },
        set(v) {
          this.$store.dispatch(`${ this.form }/SET_FIELD`, { key: this.field, value: v })
        },
      },
    },
    methods: {
      focus(e) {
        // autofill hack
        setTimeout(() => {
          if(e.target.attributes.getNamedItem('aria-activedescendant')) {
            document.getElementById(e.target.attributes.getNamedItem('aria-activedescendant').value).click()
          }
        }, 20)
      },
    },
  }
</script>

<template>
  <div class="ma-0 pa-0">
    <v-autocomplete
      :val="model"
      :dense="dense"
      @focus="focus"
      autocomplete="on"
      v-model="model"
      :placeholder="placeholder"
      :rules="rules"
      outlined
      :label="label"
      :items="items"
      :item-color="color"
      :disabled="disabled"

    />
    <v-text-field
      style="display: none;"
      v-model="model"
      :dense="dense"
      class="hiddenval"
      :maxlength="maxlength || 64"
      :placeholder="placeholder"
      :rules="rules"
      outlined
      :label="label"
      readonly
    />
  </div>
</template>
